import {
  CREATE_ADMIN_NOTIFICATION_TEMPLATE,
  CREATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
  CREATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
  GET_ADMIN_NOTIFICATION_TEMPLATES,
  GET_ADMIN_NOTIFICATION_TEMPLATES_SUCCESS,
  GET_ADMIN_NOTIFICATION_TEMPLATES_ERROR,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES_SUCCESS,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES_ERROR,
  UPDATE_ADMIN_USER_NOTIFICATIONS,
  UPDATE_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  UPDATE_ADMIN_USER_NOTIFICATIONS_ERROR,
} from "./actionTypes"

export const getAdminNotificationTemplates = () => {
  return {
    type: GET_ADMIN_NOTIFICATION_TEMPLATES,
  }
}

export const getAdminNotificationTemplatesSuccess = templates => {
  return {
    type: GET_ADMIN_NOTIFICATION_TEMPLATES_SUCCESS,
    payload: templates,
  }
}

export const getAdminNotificationTemplatesError = error => {
  return {
    type: GET_ADMIN_NOTIFICATION_TEMPLATES_ERROR,
    payload: error,
  }
}

export const createAdminNotificationTemplate = (template, history) => {
  return {
    type: CREATE_ADMIN_NOTIFICATION_TEMPLATE,
    payload: {template, history},
  }
}

export const createAdminNotificationTemplateSuccess = templates => {
  return {
    type: CREATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
    payload: templates,
  }
}

export const createAdminNotificationTemplateError = error => {
  return {
    type: CREATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
    payload: error,
  }
}

export const updateAdminNotificationTemplate = (template, history) => {
  return {
    type: UPDATE_ADMIN_NOTIFICATION_TEMPLATE,
    payload: {template, history},
  }
}

export const updateAdminNotificationTemplateSuccess = templates => {
  return {
    type: UPDATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
    payload: templates,
  }
}

export const updateAdminNotificationTemplateError = error => {
  return {
    type: UPDATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
    payload: error,
  }
}

export const deleteAdminNotificationTemplate = (template) => {
  return {
    type: DELETE_ADMIN_NOTIFICATION_TEMPLATE,
    payload: template,
  }
}

export const deleteAdminNotificationTemplateSuccess = templates => {
  return {
    type: DELETE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
    payload: templates,
  }
}

export const deleteAdminNotificationTemplateError = error => {
  return {
    type: DELETE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
    payload: error,
  }
}

export const getAdminUserNotificationPreferences = () => {
  return {
    type: GET_ADMIN_USER_NOTIFICATION_PREFERENCES,
  }
}

export const getAdminUserNotificationPreferencesSuccess = payload => {
  return {
    type: GET_ADMIN_USER_NOTIFICATION_PREFERENCES_SUCCESS,
    payload: payload,
  }
}

export const getAdminUserNotificationPreferencesError = error => {
  return {
    type: GET_ADMIN_USER_NOTIFICATION_PREFERENCES_ERROR,
    payload: error,
  }
}

export const updateAdminUserNotifications = payload => {
  return {
    type: UPDATE_ADMIN_USER_NOTIFICATIONS,
    payload: payload,
  }
}

export const updateAdminUserNotificationsSuccess = payload => {
  return {
    type: UPDATE_ADMIN_USER_NOTIFICATIONS_SUCCESS,
    payload: payload,
  }
}

export const updateAdminUserNotificationsError = error => {
  return {
    type: UPDATE_ADMIN_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}